export const socialsData = {
  github: "https://github.com/rafay51698",
  facebook: "https://www.facebook.com/rafay51698",
  linkedIn: "https://www.linkedin.com/in/muhammad-abdul-rafay-a17006218",
  instagram: "https://www.instagram.com/rafay51698/",
//   codepen: "https://codepen.io/",
//   twitter: "https://twitter.com/",
//   reddit: "https://www.reddit.com/user/",
//   blogger: "https://www.blogger.com/",
//   medium: "https://medium.com/@",
//   stackOverflow: "https://stackoverflow.com/users/",
//   gitlab: "https://gitlab.com/",
//   youtube: "https://youtube.com/",
};